import { ONBOARDING_STEPS } from "@apsu/shared";
import { useOnboarding } from "../context/onboarding";

export function OnboardingWizard() {
	const {
		currentStep,
		completed,
		dismissed,
		loading,
		completeStep,
		skipStep,
		dismiss,
	} = useOnboarding();

	if (loading || completed || dismissed) return null;

	const step = ONBOARDING_STEPS.find((s) => s.id === currentStep);
	if (!step) return null;

	return (
		<div className="fixed bottom-4 right-4 z-50 w-80 rounded-lg border border-gray-200 bg-white p-4 shadow-lg">
			<div className="flex items-start justify-between">
				<h3 className="text-sm font-semibold text-gray-900">Getting Started</h3>
				<button
					type="button"
					onClick={dismiss}
					className="text-gray-400 hover:text-gray-600 cursor-pointer"
					aria-label="Dismiss onboarding"
				>
					<svg
						aria-hidden="true"
						className="h-4 w-4"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M6 18L18 6M6 6l12 12"
						/>
					</svg>
				</button>
			</div>
			<div className="mt-3">
				<p className="text-sm font-medium text-gray-800">{step.title}</p>
				<p className="mt-1 text-xs text-gray-500">{step.description}</p>
			</div>
			<div className="mt-4 flex gap-2">
				<button
					type="button"
					onClick={() => completeStep(step.id)}
					className="rounded bg-gray-900 px-3 py-1.5 text-xs font-medium text-white hover:bg-gray-700 cursor-pointer"
				>
					Complete
				</button>
				<button
					type="button"
					onClick={() => skipStep(step.id)}
					className="rounded border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-600 hover:bg-gray-50 cursor-pointer"
				>
					Skip
				</button>
			</div>
			<div className="mt-3 flex gap-1">
				{ONBOARDING_STEPS.map((s) => (
					<div
						key={s.id}
						className={`h-1 flex-1 rounded-full ${
							s.id === currentStep ? "bg-gray-900" : "bg-gray-200"
						}`}
					/>
				))}
			</div>
		</div>
	);
}
